import React, { useState, useEffect } from 'react'
// import NumberFormat from 'react-number-format'

// estilos
import './catalog.css';
import '../../assets/style/componentPrincipal.css'

// componentes
import { Buscar } from '../general/buscadorCatalog/Buscar'
import { ModalProgress } from '../modals/ModalProgress'
// import { ExportExcel } from '../general/exportarPlanilla/ExportExcel'
// import { VerReporte } from '../general/verReporte/VerReporte'
// import { Crear } from './Crear'
// import { DialogProfileCatalog } from './DialogProfileCatalog'

import { useCatalog } from '../../hooks/useCatalog'
import { Pagination } from '@mui/material';
// import { DialogListaCategorias } from './DialogListaCategorias';
import { Link } from 'react-router-dom';
import { DialogProfileCatalogCat } from './DialogProfileCatalogCat';

export const CatalogListCategorias = () => {

    const { categorias, handleUpdateCat, initLoadCategorias } = useCatalog()
    // const [loading, setLoading] = useState(false)
    const loading = false
    // const [openCategorias, setOpenCategorias] = useState(false)
    // console.log('--categorias tatata--', categorias)

    const [filters, setFilters] = useState({
        estado: true,
        text: '',
        check_venta: false,
        check_compra: false,
        check_activo: true,
        check_desactivo: false,
        id_categoria: '',
        page: 1,
        rows: 10
    })

    useEffect(() => {
        initLoadCategorias(filters)
    }, [initLoadCategorias, filters])

    return (
        <div className='p-container'>
            <h1 className='p-title'>Catálogo / categorías</h1>

            <div className='row p-box-searching'>
                <div className='col d-flex'>
                    <Buscar
                        filters={filters}
                        setFilters={setFilters}
                    />
                </div>
            </div>

            <div className='row p-box-filters'>
                <div className='col p-box-filters-items'>
                    <Link to="/catalogo">Ver servicios</Link>
                    <Link to="/catalogo/cat" className='selected'>Categorías</Link>
                </div >
            </div>

            {loading && <ModalProgress />}

            <div className='row'>
                <div className='col d-flex flex-wrap justify-content-start'>
                    <List
                        handleUpdateCat={handleUpdateCat}
                        categorias={categorias}
                        filters={filters}
                        setFilters={setFilters}
                        initLoadCategorias={initLoadCategorias}
                    />
                </div>
            </div>

        </div >
    )
}

const List = ({ categorias, handleUpdateCat, filters, setFilters, initLoadCategorias }) => {

    const [open, setOpen] = useState(false)
    const [initialState, setInitialState] = useState({})
    const [page, setPage] = useState(1)

    const getOne = async (item) => {
        setInitialState(item)
        setOpen(true)
    }

    const handleChange = (event, value) => {
        setPage(value)
        setFilters({
            ...filters,
            page: value
        })
    }

    return (
        <div className='p-table'>
            {/* <Pagination /> */}

            <div className="row">
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={10}
                        page={page}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global" style={{ verticalAlign: 'middle' }}>
                            <th className='text-start'>Nombre categoría</th>
                            <th>Cod. Categoría</th>
                            <th>Tipo</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categorias?.length > 0 && categorias?.map(item => (
                            <ItemList
                                item={item}
                                getOne={getOne}
                            />
                        ))}
                    </tbody>
                </table>
            </div>

            {open &&
                <DialogProfileCatalogCat
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                    handleNewCat={() => { return false }}
                    handleUpdateCat={handleUpdateCat}
                    initLoadCategorias={initLoadCategorias}
                />
            }

        </div>
    )
}

const ItemList = ({ item, getOne }) => {
    console.log('--item--', item)

    return (
        <tr key={item.id} className='p-tr-body-global'
            style={{ textTransform: 'capitalize', cursor: 'pointer', textDecoration: !item.estado ? 'line-through' : '' }}
            onClick={() => getOne(item)}
        >
            <td className="text-start">
                {item.codigo ?
                    <div className='ms-3'>{item.nombre}{' / '}{item.codigo}</div>
                    :
                    <div className='ms-3'>{item.nombre}</div>
                }
                {/* <div className='ms-3'>{item.nombre || '---'}</div> */}
            </td>
            <td className="text-center">{item.codigo || '---'}</td>
            <td className="text-center">{item.tipo || '---'}</td>
            <td className="text-center">{item.estado ? 'Habilitado' : 'Desactivado'}</td>
        </tr>
    )

}